@if (secondaryName()) {
  <span class="icon--superscript">
    <svg aria-hidden="true" class="icon" xmlns="http://www.w3.org/2000/svg">
      <use [attr.xlink:href]="secondaryLink()" [attr.href]="secondaryLink()" />
    </svg>
  </span>
}
<svg aria-hidden="true" class="icon" xmlns="http://www.w3.org/2000/svg">
  <use [attr.xlink:href]="link()" [attr.href]="link()" />
</svg>
